//法语
export default{
    今日涨跌:"Variation d'aujourd'hui",
    商品:"Marchandise",
    交割:"Livraison",
    关于我们:"à propos de nous",
    账变记录:"Enregistrements de modifications de compte",
    股票:"action",
    加密货币:"crypto-monnaie",
    加载中:"chargement...",
    已经全部加载完毕:"Tous ont été chargés",
    暂无记录:"Pas d'enregistrements",
    高级认证:"Certification avancée",
    姓名:"Nom",
    请输入姓名:"Veuillez saisir votre nom",
    护照编号:"Numéro de passeport",
    请输入护照编号:"Veuillez entrer le numéro de passeport",
    护照照片:"photo de passeport",
    申请认证:"Demander une certification",
      全球领先的期货和数字资产平台: "Plateforme mondiale leader des contrats à terme et des actifs numériques",
    提示:"indice",
    确定:"Bien sûr",
    提交失败:"Échec de la soumission",
    上传失败:"échec du téléchargement",
    身份认证:"Authentification",
    身份证号:"Numéro d'identification",
    请输入身份证号:"Veuillez entrer le numéro d'identification",
    身份证照片:"Photo d'identité",
    申请认证:"Demander une certification",
    修改资金密码:"Changer le mot de passe du fonds",
    旧密码:"ancien mot de passe",
    请输入旧密码:"Veuillez saisir l'ancien mot de passe",
    新密码:"nouveau mot de passe",
    请输入6位数字:"Veuillez saisir 6 chiffres",
    确认新密码:"Confirmez le nouveau mot de passe",
    请再次输入新密码:"Veuillez saisir à nouveau le nouveau mot de passe",
    提交:"soumettre",
    请输入新密码:"Veuillez entrer un nouveau mot de passe",
    请输入6位数新密码:"Veuillez saisir un nouveau mot de passe à 6 chiffres",
    请确认两次密码输入一致:"Veuillez confirmer que les deux mots de passe saisis sont cohérents",
    修改登录密码:"Changer le mot de passe de connexion",
    密码长度:"Mot de passe (6-12 caractères)",
    密码长度提示:"Veuillez saisir 6 à 12 caractères, y compris des chiffres ou des lettres.",
    客服:"service client",
    永续:"Durable",
    交割:"Livraison",
    永续合约:"Contrat perpétuel",
    交割合约:"Contrat de livraison",
    全仓:"Entrepôt complet",
    开多:"Ouvert longtemps",
    开空:"Ouvert court",
    价格:"prix",
    开仓金额:"Montant d'ouverture",
    可用金额:"Montant disponible",
    合约金额:"Montant du contrat",
    保证金:"marge",
    手续费:"frais de gestion",
    看涨:"haussier",
    看跌:"Baissier",
    交割时间:"Délai de livraison",
    数量:"quantité",
    持有仓位:"Occuper un poste",
    当前委托:"Commande en cours",
    历史订单:"Commandes historiques",
    暂无数据:"Pas de données",
    购买价:"prix d'achat",
    现价:"Prix ​​actuel",
    市价: "prix du marché",
    限价: "limite de prix",
    金额:"Montant",
    盈亏:"Profit et perte",
    操作:"fonctionner",
    平仓:"Position fermée",
    撤单:"Annuler la commande",
    方向:"direction",
    剩余时间:"temps restant",
    交割时间:"Délai de livraison",
    详情:"Détails",
    名称:"nom",
    最新价格:"dernier prix",
    h24涨跌:"Des hauts et des bas sur 24 heures",
    h24涨跌幅:"Augmentation et diminution sur 24h",
    请输入开仓金额:"Veuillez saisir le montant d'ouverture",
    请输入开仓价格:"Veuillez saisir le prix d'ouverture",
    确定执行撤单操作:"Etes-vous sûr de vouloir annuler la commande ?",
    确定执行平仓操作:"Êtes-vous sûr d’exécuter l’opération de clôture de position ?",
    交割合约历史:"Historique du contrat de livraison",
    历史仓位:"Positions historiques",
    到期时间:"Date d'expiration",
    闪兑:"Échange flash",
    从:"depuis",
    最大:"maximum",
    可用数量:"Quantité disponible",
    至:"à",
    复制成功:"Copié avec succès",
    基金理财:"Gestion financière du fonds",
    托管金额:"Montant du séquestre",
    总收益:"Revenu total",
    当日收益:"Revenu du jour",
    托管订单:"Commande séquestre",
    规则:"règle",
    日收益:"Revenu quotidien",
    限额:"limite",
    周期:"faire du vélo",
    天:"ciel",
    立即买入:"Acheter maintenant",
    购买:"Acheter",
    购买日:"Date d'achat",
    起息日:"date de valeur",
    派息时间:"Délai de versement des dividendes",
    每日:"tous les jours",
    计息结束日:"Date de fin de cumul des intérêts",
    提前赎回:"rachat anticipé",
    预计收益:"Revenu estimé",
    今日日收益:"Aujourd'hui (revenu quotidien)",
    最少可投:"Investissement minimum",
    最大可投:"Investissement maximal",
    请输入买入金额:"Veuillez saisir le montant de l'achat",
    可用金额:"Montant disponible",
    请输入买入金额:"Veuillez saisir le montant de l'achat",
    质押金额:"Montant de la promesse",
    累计收益:"Revenu cumulé",
    开始时间:"Heure de départ",
    结束时间:"Heure de fin",
    理财规则:"règles financières",
    理财规则1:"La gestion financière se fait en confiant l'USD à la plateforme, et l'équipe professionnelle de la plateforme effectue des arbitrages financiers.Les participants peuvent obtenir une part des revenus de gestion financière de la plateforme pendant la période de conservation des fonds.",
    收益计算:"Calcul des revenus",
    理财规则2:"Un membre dépose 10 000U sur la plateforme et choisit un produit financier avec un cycle de 5 jours et un revenu journalier de 0,3%~0,5%.Le revenu journalier est le suivant :",
    最低:"le plus bas",
    最高:"Le plus élevé",
    理财规则3:"Les deux : vous pouvez l'obtenir après 5 jours",
    理财规则4:"Les revenus sont distribués quotidiennement. Les revenus distribués peuvent être consultés et retirés à tout moment et déposés sur le capital. Après échéance, ils seront automatiquement reversés sur votre compte.",
    关于违约金:"À propos des dommages et intérêts",
    理财规则5:"Si vous souhaitez transférer le capital non expiré, des dommages-intérêts seront encourus.",
    理财规则6:"Dommages-intérêts = taux de règlement x jours restants x montant de l'investissement.",
    理财规则7:"Exemple : Le ratio de règlement des dommages et intérêts de ce produit est",
    剩余:"Restant",
    天到期投资:"Il expire dans quelques jours et le montant de l'investissement est de",
    则:"mais",
    违约金:"dommages-intérêts",
    实际退还本金为:"Le principal effectivement restitué est",
    现货账户:"compte ponctuel",
    总资产:"Actif total",
    充币:"Déposer des pièces",
    提币:"Retirer des pièces",
    闪兑:"Échange flash",
    投资组合:"portefeuille",
    冻结数量:"quantité congelée",
    帮助中心:"Centre d'aide",
    自选:"Facultatif",
    行情:"Citations",
    资金:"fonds",
    资讯:"Information",
    我的:"le mien",
    交易对:"paire de trading",
    最新价:"Dernier prix",
    成交量:"Volume",
    标记价格:"prix de référence",
    h24最高价:"Prix ​​le plus élevé sur 24h",
    h24最低价:"Prix ​​le plus bas 24h",
    h24成交量:"Volume des transactions sur 24 heures",
    h24交易额:"Volume de transactions sur 24h",
    分时:"partage de temps",
    分1:"1 point",
    分5:"5 points",
    分15:"15 points",
    分30:"30 points",
    小时1:"1 heure",
    天1:"Un jour",
    周1:"1 semaine",
    月1:"Janvier",
    委托订单:"Commande",
    最新交易:"Dernières transactions",
    买入:"Acheter",
    卖出:"vendre",
    时间:"temps",
    方向:"direction",
    取消自选成功:"Annuler la sélection avec succès",
    添加成功:"Ajouté avec succès",
    登录:"Se connecter",
    账户:"Compte",
    邮箱:"Mail",
    手机号:"Numéro de téléphone",
    请输入账户:"Veuillez entrer un compte",
    请输入邮箱:"veuillez saisir votre email",
    请输入手机号:"Veuillez entrer le numéro de téléphone",
    密码:"mot de passe",
    请输入密码:"Veuillez entrer le mot de passe",
    忘记密码:"oublié le mot de passe ?",
    还没有账号:"Pas encore de compte",
    去注册:"Allez vous inscrire",
    请输入登录账号:"Veuillez entrer votre compte de connexion",
    请输入登录密码:"s'il vous plait entrez votre mot de passe",
    登录失败:"La connexion a échoué",
    历史记录:"enregistrement de l'histoire",
    充值:"recharger",
    提现:"retirer",
    未审核:"Pas révisé",
    成功:"succès",
    失败:"échouer",
    快捷入口:"Entrée rapide",
    资金密码:"Mot de passe du fonds",
    登录密码:"mot de passe",
    账变记录:"Enregistrements de modifications de compte",
    邀请推广:"Inviter une promotion",
    通用:"Universel",
    语言:"langue",
    在线客服:"un service en ligne",
    身份认证:"Authentification",
    高级认证:"Certification avancée",
    更多:"Plus",
    帮助中心:"Centre d'aide",
    关于我们:"à propos de nous",
    退出:"quitter",
    已提交身份认证:"Vous avez soumis vos informations d'identité et elles sont en cours d'examen",
    您已完成身份认证:"Vous avez terminé la vérification de votre identité",
    您已完成高级认证:"Vous avez terminé la certification avancée",
    确定退出登录:"Êtes-vous sûr de vouloir vous déconnecter?",
    资讯:"Information",
    公告:"annonce",
    状态:"État",
    已成交:"Affaire conclue",
    委托金额:"Montant de la commission",
    剩余金额:"équilibre",
    订单类型:"Type de commande",
    市价委托:"ordre du marché",
    限价委托:"ordre limité",
    订单号:"numéro de commande",
    委托时间:"Temps de commission",
    U本位合约历史:"Historique des contrats basés sur U",
    成交数量:"Le nombre de transactions",
    实现盈亏:"Réaliser des profits et des pertes",
    推广记录:"Dossier de promotion",
    我的总推广:"Ma promotion générale",
    总充值:"Recharge totale",
    一代人数:"Nombre de générations",
    二代人数:"Nombre de deuxième génération",
    三代人数:"Nombre de trois générations",
    立即推广:"Promouvoir maintenant",
    我的推广:"ma promotion",
    用户名:"nom d'utilisateur",
    行情:"Citations",
    加密货币:"crypto-monnaie",
    外汇:"Forex",
    股票:"action",
    现货交易:"Trading au comptant",
    期货:"Trading à terme",
    热门:"Populaire",
    涨幅榜:"Liste des gagnants",
    跌幅榜:"Liste des perdants",
    快速充币:"Dépôt rapide",
    保存二维码:"Enregistrer le code QR",
    复制地址:"Copier l'adresse",
    转出地址:"Adresse de transfert (facultatif)",
    请输入转出地址:"Veuillez saisir l'adresse de transfert sortant",
    粘贴:"Pâte",
    充币数量:"Montant du dépôt",
    请输入充币数量:"Veuillez saisir le montant du dépôt",
    区块链网络:"Réseau blockchain",
    付款凭证:"Bon de paiement (télécharger une capture d'écran des détails du paiement)",
    请输入充值数量:"Veuillez saisir le montant de la recharge",
    充值通道:"Canal de recharge",
    请选择充值币种:"Veuillez sélectionner la devise de recharge",
    官方充值通道:"Chaîne de recharge officielle",
    设置密码:"définir le mot de passe",
    确认密码:"Confirmez le mot de passe",
    验证码:"Le code de vérification",
    请输入验证码:"veuillez entrer le code de vérification",
    获取验证码:"obtenir le code de vérification",
    重新发送:"Renvoyer",
    邀请码:"Code d'invitation",
    请输入邀请码:"Veuillez entrer le code d'invitation",
    我已阅读并同意:"J'ai lu et accepté",
    服务条款:"Conditions d'utilisation",
    注册:"registre",
    已有账号:"Vous avez déjà un compte",
    去登录:"Allez vous connecter",
    请再次输入密码:"Veuillez saisir à nouveau le mot de passe",
    请同意服务条款:"Veuillez accepter les conditions d'utilisation",
    注册失败:"échec de l'enregistrement",
    欢迎来到:"Bienvenue à",
    全球最大的区块链资产平台:"La plus grande plateforme d'actifs blockchain au monde",
    分享二维码:"Partager le code QR",
    链接分享:"Partage de lien",
    复制:"copie",
    您的邀请码:"votre code d'invitation",
    到数字币地址:"Vers l'adresse de la monnaie numérique",
    选择币种:"Sélectionnez la devise",
    区块链网络:"Réseau blockchain",
    提币说明:"Instructions de retrait",
    提现费用:"Frais de retrait",
    可到账数量:"Quantité disponible",
    可用:"Disponible",
    请输入支付密码:"Veuillez saisir le mot de passe de paiement",
    请输入提币数量:"Veuillez saisir le montant du retrait",
    全部:"tous",
    支付密码:"Mot de passe de paiement",
    地址:"adresse",
    委托价:"Prix ​​de la commande",
    成交时间:"Temps de transaction",
    成交金额:"Chiffre d'affaires",
    委托中:"À la commission",
    持仓中:"En position",
    平仓中:"Clôture du poste",
    已平仓:"Poste fermé",
    开仓倍数:"Ouverture multiple",
    委托价格:"Prix ​​de commission",
    收盘价:"Le dernier prix",
    收益率:"taux de retour",
    平仓时间:"Heure de fermeture",
    请输入转换数量:"Veuillez saisir la quantité de conversion",
    请上传付款凭证:"Veuillez télécharger le bon de paiement",
    开盘价:"prix d'ouverture",
    开市中:"Ouvrir",
    已休市:"Le marché a été fermé",
    美股:"Actions américaines",
    平仓价:"Le dernier prix",
    到期结算完成:"Règlement à l'échéance réalisé",
    印度股票:"actions indiennes",
    马来股票:"Actions malaisiennes",
    结算中:"Règlement",
    越南股票:"actions vietnamiennes",
    设置资金密码:"Définir le mot de passe du fonds",
    请输入资金密码:"Veuillez saisir le mot de passe du fonds",
    确定:"Bien sûr",
    止损价:"Prix ​​​​stop loss",
    请输入止损价格:"Veuillez entrer le prix stop loss",
    请输入止盈价格:"Veuillez saisir le prix du take profit",
    止盈价:"Prendre le prix du bénéfice",
    设置止盈止损:"Définir le profit et le stop loss",
    请输入关键词:"Veuillez saisir un mot-clé",
    搜索结果:"Résultats de recherche",
    添加收款方式:"Ajouter un mode de paiement",
    高级认证:"Certification avancée",
    历史委托:"commande historique",
    选择区域码:"Sélectionnez l'indicatif régional",
    请上传身份证图片:"Veuillez télécharger une photo de votre carte d'identité",
    请上传护照照片:"Veuillez télécharger une photo d'identité",
    请输入提币地址:"Veuillez saisir l'adresse de retrait",
    设置语言:"Paramètres de langue",
    最低金额: "Montant minimal",
    购买金额: "prix d'achat",
    请输入要搜索的国家名称: "Veuillez saisir le nom du pays que vous souhaitez rechercher",
    确定执行该操作: "Confirmez pour le faire?",
    历史搜索: "Recherches historiques",
    现货持仓: "Position ponctuelle",
    永续持仓: "Poste perpétuel",
    到期结算中: "Règlement à l'échéance",
    火花图: "diagramme d'étincelles",
    计价单位: "unité de vente",
    您拒绝了链接: "Vous avez rejeté le lien",
    连接钱包成功: "Connexion au portefeuille réussie",
    已断开钱包: "Portefeuille déconnecté",
    钱包切换成功: "Changement de portefeuille réussi",
    请先安装钱包插件: "Veuillez d'abord installer le plug-in du portefeuille",
    连接钱包: "Connecter le portefeuille",
    交易: "commerce",
    确认报价: "Confirmer le devis",
    您将获得: "tu auras",
    兑换自: "Échanger depuis",
    汇率: "taux de change",
    返回: "retour",
    兑换: "échange",
    消息: "information",
    身份证反面照片: "Photo du verso de la carte d'identité",
    身份证正面照片: "Photo recto de la carte d'identité",
    手持身份证照片: "Photo de tenant une carte d'identité",
    划转: "transfert",
    请输入划转数量: "Veuillez saLien d'invitationisir le montant du transfert(USD)",
    邀请链接: "Lien d'invitation",
    资料总览: "Aperçu des données",
    推广规则: "Règles de promotion",
    总邀请人数: "Nombre total d'invités",
    总佣金: "commission totale",
    安全绑定: "reliure sécurisée",
    规则1: "1.Cette adresse n'accepte que {type}. Veuillez ne pas transférer d'éléments autres que {type} à cette adresse, sinon les éléments ne seront pas récupérés.",
    规则2: "2.Après avoir rechargé l'adresse ci-dessus, vous devez attendre la confirmation du nœud de réseau. Une fois que le nœud de réseau aura confirmé, les actifs arriveront automatiquement sur votre compte. Nous vous informerons de l'état d'arrivée sous la forme d'une annonce sur le site Web.",
    规则3: "3.Votre adresse de recharge ne changera pas fréquemment et vous pourrez recharger à plusieurs reprises ; en cas de changement, nous vous en informerons via une annonce sur le site Web.",

    安全中心: "Centre de sécurité",
    绑定手机号: "Lier le numéro de téléphone mobile",
    认证中心: "Centre de certification",
    身份认证: "Authentification",
    认证要求: "Exigences de certification",
    政府发行的证件: "Documents émis par le gouvernement",
    功能与限制: "Caractéristiques et limites",
    无限额: "Sans limites",
    预计审核时间: "Temps de révision estimé : 60 minutes",
    开始认证: "Commencer la certification",
    充币规则: "Règles de dépôt",
    套期保值: "Couverture, couverture des risques",
    登陆后继续: "Connectez-vous pour continuer",
    请选择充值方式: "Veuillez sélectionner le mode de dépôt",
    请选择取款方式: "Veuillez sélectionner le mode de retrait",
    客服充值: "Recharge service client",
    数字货币: "Monnaie numérique",
    银行取款: "Retrait bancaire",
    请输入金额: "Veuillez saisir le montant",
    银行名称: "Nom de la banque",
    银行卡号: "Numéro de carte bancaire",
    请输入: "Veuillez saisir",
    请选择: "Veuillez sélectionner",
    类型: "Type",
    可用金额: "Montant disponible",
    提款: "Retrait"
  }
  
  
  


// WEBPACK FOOTER //
// ./src/lang/fr.js